'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../dist-es6/client/formatters');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const{SocketTimeoutError,UnexpectedError}=require('../../../../dist-es6/client/services/socketService');
const{HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const CustomError=require('pulsar-utils/dist-es6/customError');let

FleetInsightExportFailedError=class FleetInsightExportFailedError extends CustomError{constructor(){super('FleetInsightExportFailedError')}};

const zonedMoment=require('pulsar-utils/dist-es6/time/zonedMoment');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');let


FleetInsightAnalysisButtonDirective=class FleetInsightAnalysisButtonDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/fleetInsightAnalysisButtonDirective/fleetInsightAnalysisButtonTemplate'}

get controller(){return FleetInsightAnalysisButtonDirectiveController}};let


FleetInsightAnalysisButtonDirectiveController=(_class=class FleetInsightAnalysisButtonDirectiveController{
constructor($scope,$state,$timeout,$window,userService,dateService,timeZoneService,intervalService,uiCommandFactory,flightMonitorDataService,socketService,fatigueMeterTypeContentProviderService){
this._$scope=$scope;
this._$state=$state;
this._$timeout=$timeout;
this._$window=$window;
this._userService=userService;
this._dateService=dateService;
this._timeZoneService=timeZoneService;
this._intervalService=intervalService;
this._uiCommandFactory=uiCommandFactory;
this._flightMonitorDataService=flightMonitorDataService;
this._socketService=socketService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

this.numPriorDays=3;
this.useRangeSelector=!1;
this.latestUrl=null;
this.selectedDateRange=this._intervalService.lastFourWeeksIncludingToday;

this.submitAnalysisCommand=this._uiCommandFactory.make(this.submitAnalysis.bind(this));

this.itemFormatter=rangeOption=>rangeOption.label;

const quarters=this._intervalService.getSurroundingQuartersFor(this._dateService.now());

this.rangeOptions=[{
label:'Prior 4 weeks ending today',
value:this._intervalService.lastFourWeeksIncludingToday},
{
label:'Prior calendar quarter',
value:quarters.previous},
{
label:'Prior calendar month',
value:this._intervalService.lastMonth},
{
label:'Calendar quarter that includes today',
value:quarters.current},
{
label:'Calendar month that includes today',
value:this._intervalService.thisMonth},
{
label:'Next 4 weeks starting today',
value:this._intervalService.nextFourWeeksIncludingToday},
{
label:'Next calendar quarter',
value:quarters.next},
{
label:'Next calendar month',
value:this._intervalService.nextMonth}];


this.selectedRangeOption=_.first(this.rangeOptions);

$scope.$watchGroup([
'controller.selectedRangeOption',
'controller.numPriorDays',
'controller.useRangeSelector'],
()=>this._updateReportInterval());

this._updateReportInterval();
}

_updateReportInterval(){
const range=this.useRangeSelector?this.selectedRangeOption.value:this.selectedDateRange;
this._reportInterval=TimeInterval.from(pulsarDate(range.start).minus(timespan.fromDays(this.numPriorDays))).to(range.end);
}

get reportInterval(){
return this._reportInterval;
}

formatDateString(date){
return Formatters.formatInLocale(date,'MM/DD/YYYY',this._timeZoneService.localTimeZone);
}


async submitAnalysis(){
try{
let{body:analysisResult}=await this._socketService.sendAndWaitForResponse('SubmitAnalysisToLegacyFleetInsight',{
attempt:1,
currentTime:this._dateService.now(),
groupId:null,
currentStatusSource:'effectiveStatus',
queryInterval:this.reportInterval,
numFutureDays:0,
visibleRange:null},
{
timeoutInSeconds:300,
retryOptions:{
retries:5,
maxTimeout:30000},

throwOnUnexpectedError:!0});


if(analysisResult.url){
this.latestUrl=analysisResult.url;
this._$window.open(analysisResult.url,'_blank');
}

return analysisResult;
}catch(err){
if(err instanceof SocketTimeoutError||err instanceof UnexpectedError){
throw new FleetInsightExportFailedError;
}
throw err;
}
}

get startDate(){
return this.selectedDateRange.start;
}

set startDate(startDate){
if(startDate.getTime()!==this.selectedDateRange.start.getTime()){
this.selectedDateRange=TimeInterval.from(startDate).to(this.selectedDateRange.end);
this._updateReportInterval();
}
}

get endDate(){
return this.selectedDateRange.end;
}

set endDate(endDate){
if(endDate.getTime()!==this.selectedDateRange.end.getTime()){
this.selectedDateRange=TimeInterval.from(this.selectedDateRange.start).to(endDate);
this._updateReportInterval();
}
}},(_applyDecoratedDescriptor(_class.prototype,'submitAnalysis',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'submitAnalysis'),_class.prototype)),_class);


module.exports=FleetInsightAnalysisButtonDirective;
//# sourceMappingURL=fleetInsightAnalysisButtonDirective.js.map
